export enum GridCell {
  Mine = 'mine',
  Diamond = 'diamond',
  Empty = 'empty',
}
